import React from 'react';
import CustomTextField from '../../../../shared/form-controls/custom-text-field/Custom-Text-Field';
import CustomMultiSelect from '../../../../shared/form-controls/custom-multi-select/Custom-Multi-Select';
import { DEVICE_OPTIONS } from '../../../../constants/WelcomeMessageConst';
import { Checkbox, FormControlLabel } from '@material-ui/core';

const WelcomeMessageDetails = ({ formData, handleInputChange }) => {
  const handleDeviceChange = (value) => {
    const deviceArray = value?.value || value || [];
    const deviceValues = Array.isArray(deviceArray)
      ? deviceArray.map((item) => (typeof item === 'object' ? item.id : item)).filter(Boolean)
      : [];

    handleInputChange({
      device: {
        ...formData.device,
        value: deviceValues,
        errors: {},
      },
    });
  };

  return (
    <div className='row px-3 w-100 d-flex mt-4 form-scroll'>
      <div className='row px-3 w-100 d-flex mt-3'>
        <div className='col-md-6 mb-3'>
          <CustomTextField
            item={formData?.title}
            handleInputChange={(e) => {
              handleInputChange({ title: e });
            }}
            maxLength={20}
            endAdornment={true}
            characterCount={true}
            multiline={true}
          />
        </div>
        <div className='col-md-6 mb-3'>
          <CustomMultiSelect
            item={{
              ...formData?.device,
              value: Array.isArray(formData?.device?.value) ? formData?.device?.value : [],
            }}
            handleInputChange={handleDeviceChange}
            labelField='name'
            valueField='id'
            options={DEVICE_OPTIONS}
            hideNullOption={true}
          />
        </div>
        <div className='col-md-6 mb-3'>
          <FormControlLabel
            control={
              <Checkbox
                checked={formData.isActive.value}
                onChange={(e) =>
                  handleInputChange({
                    isActive: {
                      ...formData.isActive,
                      value: e.target.checked,
                      errors: {},
                    },
                  })
                }
                color='primary'
              />
            }
            label='Active'
          />
        </div>
      </div>
    </div>
  );
};

export default WelcomeMessageDetails;